import { z } from 'zod'

const SESSION_USER_KEY = 'app.auth.user'

const sessionUserSchema = z.object({
  userId: z.string(),
  username: z.string(),
  displayName: z.string().nullable(),
  avatarUrl: z.string().nullable(),
  userRole: z.number(),
})

export type SessionUser = z.infer<typeof sessionUserSchema>

/**
 * The lightweight identity persisted alongside the tokens so the UI can
 * render the signed-in state immediately on page load. Fresh profile data
 * comes from the `me` query.
 */
export function getStoredSessionUser(): SessionUser | null {
  const raw = localStorage.getItem(SESSION_USER_KEY)
  if (!raw) return null
  try {
    return sessionUserSchema.parse(JSON.parse(raw))
  } catch {
    localStorage.removeItem(SESSION_USER_KEY)
    return null
  }
}

export function storeSessionUser(user: SessionUser): void {
  localStorage.setItem(SESSION_USER_KEY, JSON.stringify(user))
}

export function clearSessionUser(): void {
  localStorage.removeItem(SESSION_USER_KEY)
}
